import { PillMultiselect } from "@/frontend/components/ui/pill-multiselect";
import {
  EVENT_LABELS,
  WEBHOOK_EVENT_TYPES,
  type EventType,
} from "@/frontend/types/dashboard/settings/webhooks";

const OPTIONS = WEBHOOK_EVENT_TYPES.map((value) => ({
  value,
  label: EVENT_LABELS[value] ?? value,
}));

/** Webhook-event-typed wrapper around `PillMultiselect`. */
export function EventSelector({
  selected,
  onChange,
}: {
  selected: EventType[];
  onChange: (next: EventType[]) => void;
}) {
  return <PillMultiselect options={OPTIONS} selected={selected} onChange={onChange} />;
}
